import Vue from 'vue';

export default function () {
  return {
    getPackages(perfil) {
      return Vue.axios.get(`${process.env.PACKAGES_API}/packages`, {
        params: {
          pais: 'GT',
          perfil
        }
      });
    },
    getLoanPackages(perfil) {
      return Vue.axios.get(`${process.env.PACKAGES_API}/loans`, {
        params: {
          perfil
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/packagesService.js